var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoname = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 31,
  viewBox: "0 0 25.372 16",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1010 -332)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.372,
  height: 16,
  fill: "#e6e6e6",
  rx: 2,
  transform: "translate(1010 332)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a4aeaa",
  d: "M1010 335.81h25.371v2.286H1010z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 7.619,
  height: 3.048,
  fill: "rgba(164,174,170,0.5)",
  rx: 1.524,
  transform: "translate(1025.238 341.905)"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoname);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/noname.d17fedb23dd83aa916ef22196db6f82f.svg";